import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  createIndeedFlexCompany,
  type CreateIndeedFlexCompanyParams,
} from 'api/admin/indeedFlex/createIndeedFlexCompany'
import { indeedFlexKeys } from './keys'

export const useCreateIndeedFlexCompanyMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: CreateIndeedFlexCompanyParams) =>
      createIndeedFlexCompany(params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.companies(),
      })
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.clients(),
      })
    },
  })
}
